"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../shared/components/table_actions/TableActionDelete");
var TableActionEdit_1 = require("../../../../../../shared/components/table_actions/TableActionEdit");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var TableMenuIsLocked_1 = require("../../../../../../shared/components/table_menus/TableMenuIsLocked");
var EventBindingBonusesList = /** @class */ (function (_super) {
    __extends(EventBindingBonusesList, _super);
    function EventBindingBonusesList(props) {
        return _super.call(this, props) || this;
    }
    EventBindingBonusesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            totalRows: 0,
        }, function () {
            _this.props.data.LoadData(_this.props.record.key);
        });
        this.SID_LBT = this.props.listBonusTemplates.Subscribe("*", function (id, data) {
            _this.setState({
                bonusTypesAvail: data.data
            });
        });
        this.props.listBonusTemplates.LoadData(this.props.record.brand_id, this.props.record.event_type_code);
        this.props.state.setExtBreadCrumbPath(["\u0421\u043F\u0438\u0441\u043E\u043A \u0431\u043E\u043D\u0443\u0441\u043E\u0432 - [" + this.props.record.title + "]"]);
    };
    EventBindingBonusesList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
        this.props.listBonusTemplates.UnSubscribe(this.SID_LBT);
    };
    EventBindingBonusesList.prototype.doLockUnLockAction = function (Key, Title, Lock) {
        this.props.data.SetIsLocked(Key, Lock, function () {
            if (Lock) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0428\u0430\u0431\u043B\u043E\u043D \u0431\u043E\u043D\u0443\u0441\u0430 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0428\u0430\u0431\u043B\u043E\u043D \u0431\u043E\u043D\u0443\u0441\u0430 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0440\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
        });
    };
    EventBindingBonusesList.prototype.getColumnsNoAmount = function () {
        var _this = this;
        return ([{
                title: 'Бонус',
                dataIndex: this.props.data.dk_bonus_template_title,
                key: this.props.data.dk_bonus_template_title,
                width: 200,
            }, {
                title: 'Тип',
                dataIndex: this.props.data.dk_bonus_template_type_title,
                key: this.props.data.dk_bonus_template_type_title,
                width: 200,
            } /*, {
                title: 'Добавлен',
                dataIndex: this.props.data.dk_date_added,
                key: this.props.data.dk_date_added,
                width: 200,
                render: (text, record, idx) => {
                    return (
                        <div>{record.date_added.format(this.props.state.getDateTimeFormat())}</div>
                    )
                }
            }*/,
            {
                title: 'Заблокирован',
                dataIndex: this.props.data.dk_is_locked,
                key: this.props.data.dk_is_locked,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsLocked_1.default, { lockedTexts: { menu: "Заблокировать бонус", text: "Да" }, unlockedTexts: { menu: "Разблокировать бонус", text: "Нет" }, record: { key: record.key, title: record.bonus_template_title, locked: record.is_locked }, onLockClick: _this.doLockUnLockAction.bind(_this) }));
                },
                width: 150,
            }, {
                title: 'Комментарий',
                dataIndex: this.props.data.dk_description,
                key: this.props.data.dk_description,
                width: 200,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }))); },
                width: 120
            }
        ]);
    };
    EventBindingBonusesList.prototype.getColumnsWithAmount = function () {
        var _this = this;
        return ([{
                title: 'Бонус',
                dataIndex: this.props.data.dk_bonus_template_title,
                key: this.props.data.dk_bonus_template_title,
                width: 200,
            }, {
                title: 'Тип',
                dataIndex: this.props.data.dk_bonus_template_type_title,
                key: this.props.data.dk_bonus_template_type_title,
                width: 200,
            }, {
                title: 'Мин сумма (>=)',
                dataIndex: this.props.data.dk_is_greater_or_eq_min_dep_amt_only,
                key: this.props.data.dk_is_greater_or_eq_min_dep_amt_only,
                width: 200,
                render: function (text, record, idx) {
                    if (record.is_greater_or_eq_min_dep_amt_only) {
                        return (React.createElement("div", null, record.min_deposit_amount.toFixed(2)));
                    }
                    else {
                        return (React.createElement("div", null, "\u043D\u0435\u0442"));
                    }
                }
            }, {
                title: 'Макс сумма (<)',
                dataIndex: this.props.data.dk_is_lower_max_dep_amt_only,
                key: this.props.data.dk_is_lower_max_dep_amt_only,
                width: 200,
                render: function (text, record, idx) {
                    if (record.is_lower_max_dep_amt_only) {
                        return (React.createElement("div", null, record.max_deposit_amount.toFixed(2)));
                    }
                    else {
                        return (React.createElement("div", null, "\u043D\u0435\u0442"));
                    }
                }
            } /*, {
                title: 'Добавлен',
                dataIndex: this.props.data.dk_date_added,
                key: this.props.data.dk_date_added,
                width: 200,
                render: (text, record, idx) => {
                    return (
                        <div>{record.date_added.format(this.props.state.getDateTimeFormat())}</div>
                    )
                }
            }*/,
            {
                title: 'Заблокирован',
                dataIndex: this.props.data.dk_is_locked,
                key: this.props.data.dk_is_locked,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsLocked_1.default, { lockedTexts: { menu: "Заблокировать бонус", text: "Да" }, unlockedTexts: { menu: "Разблокировать бонус", text: "Нет" }, record: { key: record.key, title: record.bonus_template_title, locked: record.is_locked }, onLockClick: _this.doLockUnLockAction.bind(_this) }));
                },
                width: 120,
            }, {
                title: 'Комментарий',
                dataIndex: this.props.data.dk_description,
                key: this.props.data.dk_description,
                width: 200,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }))); },
                width: 120
            }
        ]);
    };
    EventBindingBonusesList.prototype.getColumns = function () {
        if (this.props.record.is_need_amount) {
            return this.getColumnsWithAmount();
        }
        else {
            return this.getColumnsNoAmount();
        }
    };
    EventBindingBonusesList.prototype.onEditClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    EventBindingBonusesList.prototype.onDeleteClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u0428\u0430\u0431\u043B\u043E\u043D \u0431\u043E\u043D\u0443\u0441\u0430 ",
                React.createElement("b", null,
                    "[",
                    record.bonus_template_title,
                    "]"),
                " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D"));
        });
    };
    EventBindingBonusesList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData(this.props.record.key);
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
        if (action == "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
    };
    EventBindingBonusesList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { back: "Назад", create: "Создать", refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.getColumns(), dataSource: this.state.data, pagination: {
                    pageSize: this.props.state.UITablePageSize,
                    showSizeChanger: true,
                    total: this.state.totalRows,
                    position: "bottom",
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added.format(_this.props.state.getDateTimeFormat()),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                            " [",
                            record.date_changed.format(_this.props.state.getDateTimeFormat()),
                            "]")));
                } })));
    };
    return EventBindingBonusesList;
}(React.Component));
exports.default = EventBindingBonusesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_events_bindings/ui/component/EventBindingBonusesList.tsx
// module id = 1980
// module chunks = 0